import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus(complexDenominator, c1, c2, c5, r1, sImaginary) {
  var result = Complex.createComplex(1, sImaginary * (c1 * r1 + c2 * r1 + c5 * r1)).divide(complexDenominator);
  return result;
}

export function computeComplexFF(complexFFDenominator, c1, c2, r1, rOut, sImaginary, sSquared) {
  var complexFFNumerator = Complex.createComplex(sSquared * rOut * c1 * c2 * r1, sImaginary * rOut * c2);
  var result = complexFFNumerator.divide(complexFFDenominator);
  return result;
}
